import React, { useEffect, useState } from "react";

//service
import {
  fetchAllUsers
} from "../services/api";

function Auction(props) {

  const [users, setUsers] = useState([]);

  const fetchData = async () => {
    const data = await fetchAllUsers();

    setUsers(data);

    console.log(data);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="header">
        <span>
          Leilão Usadão Máquinas
        </span>
      </div>
      <div className="">
      </div>
    </div>
  );
}

export default Auction;